import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Contingent from '../../../models/contingentModel';
import { WeezHeader, Button, Card, FilterSetController } from '@weezevent/nacre';
import { Trans, useTranslation } from 'react-i18next';
import DeleteModal from './deleteModal';
import ContingentTable from './list';
import Style from './contingentList.module.css';

export default function ContingentList({ organization, chartId }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [contingentDeleted, setContingentDeleted] = React.useState(null);
    const [inputSearchValue, setInputSearchValue] = React.useState('');

    const [contingents, loadingContingents, syncContingents] = Contingent.useApiModel(
        {
            organizationId: organization.id,
            chartId,
            cache: false,
            allow_cache: false,
            query: {
                search: inputSearchValue
            }
        },
        [organization, inputSearchValue, chartId]
    );

    const onCloseDeleteModal = React.useCallback(() => {
        setContingentDeleted(null);
    }, []);

    const handleSearch = React.useCallback((synth, value) => {
        setInputSearchValue(value);
    }, []);

    const contingentsCount = contingents?.length || 0;

    return (
        <div className={Style['contingents-container']}>
            <WeezHeader
                title={<Trans i18nKey="ticket.charts.contingents.list.title" />}
                rightComponent={
                    <Button
                        primary
                        onClick={() => history.push(`/ticket/O${organization.id}/charts/${chartId}/contingents/new`)}
                        label={<Trans i18nKey="ticket.charts.contingents.list.add-contingent" />}
                    />
                }
            />
            <Card>
                <Card.Content>
                    <FilterSetController
                        labelTotal={t('ticket.charts.contingents.list.contingent', { count: contingentsCount })}
                        onChange={() => {}}
                        search={{
                            onChange: (synth, value) => {
                                handleSearch(synth, value);
                            },
                            handleReset: () => {
                                handleSearch('');
                            },
                            placeholder: t('ticket.charts.contingents.list.search-contingent'),
                            value: inputSearchValue
                        }}
                        total={contingentsCount}
                        isLoadingTotal={loadingContingents}
                    />
                </Card.Content>
                <DeleteModal contingent={contingentDeleted} syncContingents={syncContingents} organization={organization} onClose={onCloseDeleteModal} chartId={chartId} />
                <ContingentTable
                    organization={organization}
                    chartId={chartId}
                    contingents={contingents}
                    loadingContingents={loadingContingents}
                    onContingentDeleted={setContingentDeleted}
                    inputSearchValue={inputSearchValue}
                />
            </Card>
        </div>
    );
}

ContingentList.propTypes = {
    chartId: PropTypes.string.isRequired,
    organization: PropTypes.object.isRequired
};
